import { useState, type FormEvent } from "react";
import { setAdminClientSecret } from "@/utils/adminAuth";

type AdminSecretGateProps = {
  onSignIn: (secret: string) => void;
};

export const AdminSecretGate = ({ onSignIn }: AdminSecretGateProps) => {
  const [secret, setSecret] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const trimmed = secret.trim();

    if (!trimmed) {
      setError("Enter your admin secret to continue.");
      return;
    }

    setAdminClientSecret(trimmed);
    setError(null);
    onSignIn(trimmed);
  };

  return (
    <div className="admin-secret-gate">
      <form className="admin-secret-form" onSubmit={handleSubmit}>
        <h1 className="admin-secret-title">Bouncer Admin</h1>
        <p className="admin-secret-hint">
          Enter <code>ADMIN_INGEST_SECRET</code> from your server environment.
        </p>
        <label className="admin-secret-label" htmlFor="admin-secret">
          Admin secret
        </label>
        <input
          id="admin-secret"
          className="admin-secret-input"
          type="password"
          autoComplete="current-password"
          value={secret}
          onChange={(event) => setSecret(event.target.value)}
          placeholder="Paste secret"
        />
        {error ? <p className="admin-secret-error">{error}</p> : null}
        <button className="admin-secret-submit" type="submit">
          Sign in
        </button>
      </form>
    </div>
  );
};
